<section class="account-page">
  <div class="container py-40">
    <div class="account-layout">
      <!-- Sidebar -->
      <aside class="account-sidebar">
        <div class="sidebar-card">
          <nav class="sidebar-menu">
            <a class="sidebar-item" [class.active]="view === 'reservations'" (click)="setView('reservations')">
              <span class="sidebar-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </span>
              Rezervasyonlarım
              <span class="sidebar-item__badge">{{ active.length + past.length }}</span>
            </a>
            <a class="sidebar-item" [class.active]="view === 'coupons'" (click)="setView('coupons')">
              <span class="sidebar-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/><path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/><path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z"/></svg>
              </span>
              Kuponlarım
              <span class="sidebar-item__badge" *ngIf="activeCoupons.length > 0">{{ activeCoupons.length }}</span>
            </a>
            <a class="sidebar-item" [class.active]="view === 'profile'" (click)="setView('profile')">
              <span class="sidebar-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </span>
              Profil Bilgileri
            </a>
            <a class="sidebar-item" [class.active]="view === 'passengers'" (click)="setView('passengers')">
              <span class="sidebar-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </span>
              Kayıtlı Kişiler
              <span class="sidebar-item__badge" *ngIf="passengers.length > 0">{{ passengers.length }}</span>
            </a>
            <a class="sidebar-item" [class.active]="view === 'invoices'" (click)="setView('invoices')">
              <span class="sidebar-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="14 2 14 8 20 8"/><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/></svg>
              </span>
              Fatura Bilgileri
              <span class="sidebar-item__badge" *ngIf="invoices.length > 0">{{ invoices.length }}</span>
            </a>
          </nav>
        </div>
      </aside>

      <!-- Main Content -->
      <div class="account-content">
        <!-- Rezervasyonlar -->
        <ng-container *ngIf="view === 'reservations'">
          <div class="content-header">
            <h2 class="content-header__title">Rezervasyonlarım</h2>
            <div class="content-tabs">
              <button class="tab-pill" [class.active]="activeTab === 'active'" (click)="setTab('active')">
                Aktif <span class="tab-pill__count">{{ active.length }}</span>
              </button>
              <button class="tab-pill" [class.active]="activeTab === 'past'" (click)="setTab('past')">
                Geçmiş <span class="tab-pill__count">{{ past.length }}</span>
              </button>
            </div>
          </div>

          <div *ngIf="loading" class="state-box">
            <div class="spinner"></div>
            <p>Rezervasyonlar yükleniyor...</p>
          </div>

          <div *ngIf="error" class="state-box state-box--error">
            <p>{{ error }}</p>
            <button class="btn-primary" (click)="load()">Tekrar Dene</button>
          </div>

          <ng-container *ngIf="!loading && !error">
            <ng-container *ngIf="(activeTab === 'active' ? active : past) as list">
              <div *ngIf="list.length === 0" class="state-box">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <h3>{{ activeTab === 'active' ? 'Aktif rezervasyonunuz yok' : 'Geçmiş rezervasyonunuz yok' }}</h3>
                <p>{{ activeTab === 'active' ? 'Yeni bir tatil planlamaya ne dersiniz?' : 'Henüz tamamlanmış bir rezervasyonunuz bulunmuyor.' }}</p>
                <a routerLink="/" class="btn-primary">Otel Ara</a>
              </div>

              <div *ngFor="let r of list" class="res-card">
                <div class="res-card__left">
                  <div class="res-card__hotel-icon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9v.01"/><path d="M9 12v.01"/><path d="M9 15v.01"/><path d="M9 18v.01"/></svg>
                  </div>
                </div>
                <div class="res-card__body">
                  <div class="res-card__header">
                    <div>
                      <h3 class="res-card__title">{{ r.hotelName || 'Otel' }}</h3>
                      <p class="res-card__subtitle" *ngIf="r.roomName">{{ r.roomName }}</p>
                    </div>
                    <span class="status-pill" [attr.data-status]="r.status">
                      <span class="status-pill__dot"></span>
                      {{ statusLabel(r.status) }}
                    </span>
                  </div>
                  <div class="res-card__details">
                    <div class="detail">
                      <span class="detail__label">Giriş</span>
                      <span class="detail__value">{{ r.checkInDate ? (r.checkInDate | date:'dd MMM yyyy':'':'tr') : '-' }}</span>
                    </div>
                    <div class="detail-divider"></div>
                    <div class="detail">
                      <span class="detail__label">Çıkış</span>
                      <span class="detail__value">{{ r.checkOutDate ? (r.checkOutDate | date:'dd MMM yyyy':'':'tr') : '-' }}</span>
                    </div>
                    <div class="detail-divider"></div>
                    <div class="detail">
                      <span class="detail__label">Tutar</span>
                      <span class="detail__value detail__value--price">{{ r.paidPrice | number:'1.2-2' }} {{ r.currency }}</span>
                    </div>
                    <div class="detail-divider" *ngIf="r.bookingNumber"></div>
                    <div class="detail" *ngIf="r.bookingNumber">
                      <span class="detail__label">Rezervasyon No</span>
                      <span class="detail__value">{{ r.bookingNumber }}</span>
                    </div>
                  </div>
                  <div class="res-card__footer">
                    <span class="res-card__date">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                      {{ r.createdAt | date:'dd.MM.yyyy HH:mm' }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- Kuponlar -->
        <ng-container *ngIf="view === 'coupons'">
          <div class="content-header">
            <h2 class="content-header__title">Kuponlarım</h2>
            <div class="content-tabs">
              <button class="tab-pill" [class.active]="couponTab === 'active'" (click)="setCouponTab('active')">
                Aktif <span class="tab-pill__count">{{ activeCoupons.length }}</span>
              </button>
              <button class="tab-pill" [class.active]="couponTab === 'used'" (click)="setCouponTab('used')">
                Kullanılan <span class="tab-pill__count">{{ usedCoupons.length }}</span>
              </button>
              <button class="tab-pill" [class.active]="couponTab === 'expired'" (click)="setCouponTab('expired')">
                Süresi Dolmuş <span class="tab-pill__count">{{ expiredCoupons.length }}</span>
              </button>
            </div>
          </div>

          <div *ngIf="couponsLoading" class="state-box">
            <div class="spinner"></div>
            <p>Kuponlar yükleniyor...</p>
          </div>

          <div *ngIf="couponsError" class="state-box state-box--error">
            <p>{{ couponsError }}</p>
            <button class="btn-primary" (click)="loadCoupons()">Tekrar Dene</button>
          </div>

          <ng-container *ngIf="!couponsLoading && !couponsError">
            <ng-container *ngIf="currentCouponList() as list">
              <div *ngIf="list.length === 0" class="state-box">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/><path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/><path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z"/></svg>
                <h3>Bu kategoride kupon yok</h3>
                <p>Hesabınıza tanımlanmış bir kupon bulunmuyor.</p>
              </div>

              <div class="coupon-grid">
                <div *ngFor="let uc of list" class="coupon-card" [class.coupon-card--used]="uc.isUsed" [class.coupon-card--expired]="uc.isExpired">
                  <div class="coupon-card__left">
                    <div class="coupon-card__discount">{{ formatDiscount(uc) }}</div>
                    <div class="coupon-card__discount-label">İNDİRİM</div>
                  </div>
                  <div class="coupon-card__perforation"><i></i></div>
                  <div class="coupon-card__right">
                    <div class="coupon-card__head">
                      <h4 class="coupon-card__title">{{ uc.coupon.title }}</h4>
                      <div class="coupon-card__desc" *ngIf="uc.coupon.description" [innerHTML]="uc.coupon.description"></div>
                    </div>
                    <div class="coupon-card__code-row">
                      <span class="coupon-card__code" *ngIf="!uc.coupon.codeHidden">{{ uc.coupon.code }}</span>
                      <span class="coupon-card__code coupon-card__code--locked" *ngIf="uc.coupon.codeHidden" title="İlk rezervasyonunuzdan sonra açılacak">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                      </span>
                      <span class="coupon-card__valid">
                        Son: {{ uc.coupon.validUntil | date:'dd MMM yyyy':'':'tr' }}
                      </span>
                    </div>
                    <div class="coupon-card__meta" *ngIf="uc.coupon.minAmount">
                      Min. {{ uc.coupon.minAmount | number:'1.0-0' }} ₺ harcamada geçerli
                    </div>
                    <div class="coupon-card__status" *ngIf="uc.isUsed">✓ Kullanıldı</div>
                    <div class="coupon-card__status coupon-card__status--expired" *ngIf="uc.isExpired && !uc.isUsed">Süresi Doldu</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- Profil -->
        <ng-container *ngIf="view === 'profile'">
          <div class="content-header">
            <h2 class="content-header__title">Profil Bilgileri</h2>
          </div>

          <div *ngIf="profileLoading" class="state-box">
            <div class="spinner"></div>
            <p>Yükleniyor...</p>
          </div>

          <ng-container *ngIf="!profileLoading">
            <div class="profile-card">
              <div class="profile-card__head">
                <div class="profile-big-avatar">{{ initial }}</div>
                <div>
                  <div class="profile-card__name">{{ profile?.fullName || profileForm.firstName + ' ' + profileForm.lastName }}</div>
                  <div class="profile-card__email">{{ profile?.email }}</div>
                </div>
              </div>

              <div class="profile-form">
                <div class="form-row">
                  <div class="form-field">
                    <label>Ad</label>
                    <input type="text" [(ngModel)]="profileForm.firstName" />
                  </div>
                  <div class="form-field">
                    <label>Soyad</label>
                    <input type="text" [(ngModel)]="profileForm.lastName" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-field">
                    <label>E-posta</label>
                    <input type="email" [value]="profileForm.email" disabled />
                    <span class="form-hint">E-posta adresi değiştirilemez</span>
                  </div>
                  <div class="form-field">
                    <label>Telefon</label>
                    <input type="tel" [(ngModel)]="profileForm.phoneNumber" placeholder="05XX XXX XX XX" />
                  </div>
                </div>

                <div *ngIf="profileMessage" class="form-message" [class.success]="profileMessageSuccess" [class.error]="!profileMessageSuccess">
                  {{ profileMessage }}
                </div>

                <div class="form-actions">
                  <button class="btn-primary" (click)="saveProfile()" [disabled]="profileSaving">
                    {{ profileSaving ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet' }}
                  </button>
                </div>
              </div>
            </div>

          </ng-container>
        </ng-container>

        <!-- Kayıtlı Kişiler -->
        <ng-container *ngIf="view === 'passengers'">
          <div class="content-header">
            <h2 class="content-header__title">Kayıtlı Kişiler</h2>
            <button class="btn-primary" (click)="openAddPassenger()" *ngIf="!showPassengerForm">
              + Yeni Kişi Ekle
            </button>
          </div>

          <div class="passengers-info-box">
            Beraber seyahat ettiğiniz kişilerin bilgilerini kaydedebilir, rezervasyon yaparken kolayca seçebilirsiniz.
          </div>

          <div *ngIf="passengersLoading" class="state-box">
            <div class="spinner"></div>
            <p>Yükleniyor...</p>
          </div>

          <ng-container *ngIf="!passengersLoading">
            <!-- Listing -->
            <div *ngFor="let p of passengers" class="passenger-card">
              <div class="passenger-card__left">
                <div class="passenger-avatar" [class.self]="p.isSelf">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                </div>
                <div>
                  <div class="passenger-name">
                    {{ p.firstName }} {{ p.lastName }}
                    <span class="passenger-self-badge" *ngIf="p.isSelf">Kendim</span>
                  </div>
                  <div class="passenger-missing" *ngIf="hasMissingInfo(p)">
                    <span class="dot"></span> Eksik bilgi var, tamamlayın.
                  </div>
                </div>
              </div>
              <div class="passenger-card__right">
                <button class="link-btn" (click)="openEditPassenger(p)">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  Güncelle
                </button>
                <button class="link-btn link-btn--danger" (click)="deletePassenger(p)" *ngIf="!p.isSelf">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/></svg>
                </button>
              </div>
            </div>

            <div *ngIf="passengers.length === 0 && !showPassengerForm" class="state-box">
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
              <h3>Henüz kayıtlı kişi yok</h3>
              <p>Yeni kişi ekleyerek rezervasyonda hızlı seçim yapabilirsiniz.</p>
              <button class="btn-primary" (click)="openAddPassenger()">+ Yeni Kişi Ekle</button>
            </div>

            <!-- Form -->
            <div class="passenger-form-card" *ngIf="showPassengerForm">
              <div class="profile-section-title">
                {{ editingPassengerId ? 'Kişiyi Düzenle' : 'Yeni Kişi Ekle' }}
              </div>

              <div class="gender-row">
                <label class="gender-option">
                  <input type="radio" name="gender" value="Female" [(ngModel)]="passengerForm.gender" />
                  <span>Kadın</span>
                </label>
                <label class="gender-option">
                  <input type="radio" name="gender" value="Male" [(ngModel)]="passengerForm.gender" />
                  <span>Erkek</span>
                </label>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <input type="text" [(ngModel)]="passengerForm.firstName" placeholder="İsim" />
                </div>
                <div class="form-field">
                  <input type="text" [(ngModel)]="passengerForm.lastName" placeholder="Soyisim" />
                </div>
              </div>

              <div class="form-row" *ngIf="!editingPassengerId || !passengerForm.isSelf">
                <div class="form-field">
                  <input type="tel" [(ngModel)]="passengerForm.phoneNumber" placeholder="Telefon Numarası" />
                </div>
                <div class="form-field">
                  <input type="email" [(ngModel)]="passengerForm.email" placeholder="E-Posta Adresi" />
                </div>
              </div>

              <label class="checkbox-row">
                <input type="checkbox" [(ngModel)]="passengerForm.isForeign" />
                <span>T.C. Vatandaşı Değilim</span>
              </label>

              <div class="form-row">
                <div class="form-field">
                  <input type="text"
                    [(ngModel)]="passengerForm.tcNumber"
                    placeholder="TC Kimlik Numarası"
                    [disabled]="passengerForm.isForeign"
                    maxlength="11" />
                </div>
                <div class="form-field">
                  <input type="date" [(ngModel)]="passengerForm.birthDate" placeholder="Doğum Tarihi" />
                </div>
              </div>

              <label class="checkbox-row" *ngIf="!editingPassengerId">
                <input type="checkbox" [(ngModel)]="passengerForm.isSelf" />
                <span>Bu kayıt kendime ait</span>
              </label>

              <div *ngIf="passengerMessage" class="form-message error">{{ passengerMessage }}</div>

              <div class="passenger-form-actions">
                <button class="btn-primary" (click)="savePassenger()" [disabled]="passengerSaving">
                  {{ passengerSaving ? 'Kaydediliyor...' : 'Kaydet' }}
                </button>
                <button class="link-btn" (click)="cancelPassengerForm()">Vazgeç</button>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Fatura Bilgileri -->
        <ng-container *ngIf="view === 'invoices'">
          <div class="content-header">
            <h2 class="content-header__title">Fatura Bilgileri</h2>
            <button class="btn-primary" (click)="openAddInvoice()" *ngIf="!showInvoiceForm">
              + Yeni Fatura Profili
            </button>
          </div>

          <div class="passengers-info-box">
            Fatura profillerinizi kaydedin; rezervasyon sırasında kurumsal fatura seçeneğinde tek tıkla kullanın.
          </div>

          <div *ngIf="invoicesLoading" class="state-box">
            <div class="spinner"></div>
            <p>Yükleniyor...</p>
          </div>

          <ng-container *ngIf="!invoicesLoading">
            <div *ngFor="let p of invoices" class="invoice-card">
              <div class="invoice-card__left">
                <div class="invoice-icon" [class.corp]="p.type === 'Corporate'">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path *ngIf="p.type === 'Corporate'" d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"/>
                    <path *ngIf="p.type !== 'Corporate'" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle *ngIf="p.type !== 'Corporate'" cx="12" cy="7" r="4"/>
                  </svg>
                </div>
                <div>
                  <div class="invoice-card__title">
                    {{ p.title }}
                    <span class="passenger-self-badge" *ngIf="p.isDefault">Varsayılan</span>
                    <span class="invoice-type-badge" [class.corp]="p.type === 'Corporate'">
                      {{ p.type === 'Corporate' ? 'Kurumsal' : 'Bireysel' }}
                    </span>
                  </div>
                  <div class="invoice-card__sub">
                    <ng-container *ngIf="p.type === 'Corporate'">{{ p.companyName }} · {{ p.taxOffice }} / {{ p.taxNumber }}</ng-container>
                    <ng-container *ngIf="p.type !== 'Corporate'">{{ p.personalName }} {{ p.personalSurname }} · TC: {{ p.tcNumber }}</ng-container>
                  </div>
                </div>
              </div>
              <div class="passenger-card__right">
                <button class="link-btn" (click)="openEditInvoice(p)">Güncelle</button>
                <button class="link-btn link-btn--danger" (click)="deleteInvoice(p)">Sil</button>
              </div>
            </div>

            <div *ngIf="invoices.length === 0 && !showInvoiceForm" class="state-box">
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><polyline points="14 2 14 8 20 8"/><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/></svg>
              <h3>Henüz fatura profili yok</h3>
              <p>Hızlı rezervasyon için fatura profili ekleyin.</p>
              <button class="btn-primary" (click)="openAddInvoice()">+ Yeni Fatura Profili</button>
            </div>

            <!-- Form -->
            <div class="passenger-form-card" *ngIf="showInvoiceForm">
              <div class="profile-section-title">
                {{ editingInvoiceId ? 'Fatura Profili Düzenle' : 'Yeni Fatura Profili' }}
              </div>

              <div class="gender-row">
                <label class="gender-option">
                  <input type="radio" name="invType" value="Corporate" [(ngModel)]="invoiceForm.type" />
                  <span>Kurumsal</span>
                </label>
                <label class="gender-option">
                  <input type="radio" name="invType" value="Personal" [(ngModel)]="invoiceForm.type" />
                  <span>Bireysel</span>
                </label>
              </div>

              <div class="form-field">
                <input type="text" [(ngModel)]="invoiceForm.title" placeholder="Profil adı (örn: İş Yerim)" />
              </div>

              <ng-container *ngIf="invoiceForm.type === 'Corporate'">
                <div class="form-row">
                  <div class="form-field">
                    <input type="text" [(ngModel)]="invoiceForm.companyName" placeholder="Firma Ünvanı *" />
                  </div>
                  <div class="form-field">
                    <input type="text" [(ngModel)]="invoiceForm.taxOffice" placeholder="Vergi Dairesi *" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-field">
                    <input type="text" [(ngModel)]="invoiceForm.taxNumber" placeholder="Vergi Numarası *" maxlength="11" />
                  </div>
                  <div class="form-field">
                    <input type="text" [(ngModel)]="invoiceForm.companyCity" placeholder="İl" />
                  </div>
                </div>
                <div class="form-field">
                  <input type="text" [(ngModel)]="invoiceForm.companyAddress" placeholder="Adres" />
                </div>
                <div class="form-row">
                  <div class="form-field">
                    <input type="tel" [(ngModel)]="invoiceForm.companyPhoneNumber" placeholder="Telefon" />
                  </div>
                  <div class="form-field">
                    <input type="email" [(ngModel)]="invoiceForm.companyEmail" placeholder="E-posta" />
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="invoiceForm.type === 'Personal'">
                <div class="form-row">
                  <div class="form-field">
                    <input type="text" [(ngModel)]="invoiceForm.personalName" placeholder="Ad *" />
                  </div>
                  <div class="form-field">
                    <input type="text" [(ngModel)]="invoiceForm.personalSurname" placeholder="Soyad *" />
                  </div>
                </div>
                <div class="form-field">
                  <input type="text" [(ngModel)]="invoiceForm.tcNumber" placeholder="TC Kimlik No *" maxlength="11" />
                </div>
              </ng-container>

              <label class="checkbox-row">
                <input type="checkbox" [(ngModel)]="invoiceForm.isDefault" />
                <span>Varsayılan fatura profili olarak ayarla</span>
              </label>

              <div *ngIf="invoiceMessage" class="form-message error">{{ invoiceMessage }}</div>

              <div class="passenger-form-actions">
                <button class="btn-primary" (click)="saveInvoice()" [disabled]="invoiceSaving">
                  {{ invoiceSaving ? 'Kaydediliyor...' : 'Kaydet' }}
                </button>
                <button class="link-btn" (click)="cancelInvoiceForm()">Vazgeç</button>
              </div>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>
  </div>
</section>
